/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */


document.addEventListener('DOMContentLoaded', () => {

    const splides = document.querySelectorAll('.image-carousel');

    if (!!splides && splides.length > 0) {
        splides.forEach(splide => {
            const slides_count = splide.querySelectorAll('.splide__slide');
            const interval = parseInt(splide.dataset.interval) * 1000 || 3000;
            const isAutoplay = splide.dataset.autoplay === "true";
            const isPauseOnHover = splide.dataset.pauseonhover === "true";
            const imagesPerSlideMob = parseInt(splide.dataset.imagesperslidemob);
            const imagesPerSlideTab = parseInt(splide.dataset.imagesperslidetab);
            const imagesPerSlideDesk = parseInt(splide.dataset.imagesperslidedesk);
            splide.setAttribute('aria-label', 'Image carousel');
            const breakpoints = {
                // Mobile View (up to 640px)
                640: {
                    perPage: imagesPerSlideMob,  // Show only one slide on screens below 640px
                },
                // Tablet View (between 640px and 1024px)
                1024: {
                    perPage: imagesPerSlideTab,  // Show two slides on screens between 640px and 1024px
                },
                // Desktop View (above 1024px)
                2560: {  // "inf" represents infinity, targeting screens larger than 1024px
                    perPage: imagesPerSlideDesk,  // Show three slides on desktops
                }
            };

            const thumbnailCarousels = document.getElementById('thumbnail-slider');

            if (thumbnailCarousels) {
                var splideInstance = new Splide(splide, {
                    type: 'fade',
                    rewind: true,
                    pagination: false,
                    arrows: false,
                });

                const thumbnailCarousel = new Splide("#thumbnail-slider", {
                    fixedWidth: 75,
                    fixedHeight: 75,
                    gap: 5,
                    rewind: true,
                    pagination: false,
                    isNavigation: true,
                    breakpoints: {
                        600: {
                            fixedWidth: 50,
                            fixedHeight: 50,
                        },
                    },
                });
                splideInstance.sync(thumbnailCarousel);
                // Mount both carousels
                splideInstance.mount();
                thumbnailCarousel.mount();
            } else {
                var splideInstance = new Splide(splide, {
                    role: 'group',
                    classes: {
                    }, type: slides_count.length > (imagesPerSlideDesk - 1) ? 'loop' : 'slide', gap: '1.5rem', autoplay: isAutoplay, perPage: imagesPerSlideDesk, perMove: 1, pauseOnHover: isPauseOnHover, interval: interval, breakpoints: breakpoints
                });
                splideInstance.mount();
                // Remove role="presentation" from the list
                splide.querySelectorAll('.splide__list[role="presentation"]').forEach(list => {
                    list.removeAttribute('role');
                });
                splideInstance.on('mounted moved', () => {
                    splide.querySelectorAll('.splide__slide--clone').forEach(clone => {
                        clone.setAttribute('aria-hidden', 'true');
                        clone.removeAttribute('role');
                        clone.removeAttribute('aria-label');
                        clone.removeAttribute('aria-roledescription');
                    });
                });
            }
            const slides = splide.querySelectorAll('.splide__slide');
            slides.forEach(slide => {
                slide.setAttribute('role', 'region');
            });
            const arrows = splide.querySelector('.splide__arrows');
            if (arrows) {
                arrows.setAttribute('role', 'group');
                arrows.setAttribute('aria-label', 'Image slider arrows');
            }
        })
    }
})
